import { createFeature, createReducer, on } from '@ngrx/store';

import { SecurityActions } from './security.actions';

interface State {
  isAuthenticated: boolean;
  userId: string | null;
}

const initialState: State = {
  isAuthenticated: false,
  userId: null,
};

export const appFeature = createFeature({
  name: 'app',
  reducer: createReducer(
    initialState,
    on(SecurityActions.signInSuccess, (state) => ({
      ...state,
      isAuthenticated: true,
    })),
    on(
      SecurityActions.authenticateSuccess,
      (state, { userId }): State => ({
        ...state,
        userId,
      })
    )
  ),
});

export const { selectIsAuthenticated, selectUserId } =
  appFeature;
